module.exports = "pegasus/assets/web_template/web_template_logo.png";